<template>
  <Field
    data-cy="policy"
    :rules="{ required: { allowFalse: false } }"
    type="checkbox"
    :value="value"
    @update:value="$emit('update:value', $event)">
    <span slot="label">
      {{ $t('read') }} <Route to="PrivacyPolicy">
        {{ $t('policy') }}
      </Route>
    </span>
  </Field>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
}
</script>

<i18n>
{
  "en": {
    "policy": "the privacy policy",
    "read": "I have read"
  }
}
</i18n>
